<template>
  <div
    class="template-modal"
    :class="{ 'template-modal--full-screen': fullScreen }"
  >
    <div class="modal">
      <div class="header">
        <label class="label--medium">{{ header }}</label>
        <i
          class="bi bi-x-lg"
          @click="$emit('close')"
        />
      </div>
      <div class="content">
        <slot name="content" />
      </div>

      <div
        v-if="$slots.footer"
        class="footer"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateModal',
  props: {
    header: {
      type: String,
      default: ''
    },
    fullScreen: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss">
.template-modal {
  @include inset-space($space-xxlarge);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  background-color: $color-white-80;
  z-index: $z-index-modal;

  @media(max-width: $mobile-breakpoint-max-width) {
    @include inset-space($space-medium);
  }

  .modal {
    @include stack-space($space-none);
    border-radius: $radius-medium;
    width: 100%;
    max-width: 630px;
    height: fit-content;
    background-color: $color-background-primary;
    box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.25);

    .header {
      @include inline-space($space-medium);
      @include inset-space($space-medium);
      color: $color-text-primary;
      label {
        flex: 1;
        color: $color-text-secondary;
      }
      i {
        font-size: $icon-small;
      }
    }

    .footer {
      @include stack-space($space-medium);
      @include inset-space($space-medium);
    }
  }


  &--full-screen.template-modal--full-screen {
    @include inset-space($space-large);
    align-items: stretch;

    .modal {
      max-width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;

      .content {
        @include stack-space($space-none);
        overflow-y: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>